import React from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';

import { daysFilterValue } from '../data';
import './DaysFilter.scss';

const b = block('days-filter');
const DaysFilter = ({ activeDay, setActiveDay, isMobile }) => {
  const locale = useSelector(state => state.locale.locale);

  return (
    <div className={b()}>
      {daysFilterValue.map(el => (
        <div
          onClick={() => setActiveDay(el)}
          key={el.text}
          className={b('item', { active: activeDay.text === el.text })}>
          {locale[el.text]}
        </div>
      ))}
    </div>
  );
};

export default DaysFilter;
